import { useState } from 'react'

const useStorage = ({ key, initialValue, type }) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window[type].getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      console.log(error)
      return initialValue
    }
  })
  const setValue = value => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
      window[type].setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      console.log(error)
    }
  }
  return [storedValue, setValue]
}

export default useStorage
